<template>
    <div>
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>          
      <!-- Application Header -->
      <header class="c-main-header-nav">
        <div class="c-responsive-container">
          <div class="c-as-block">
            <div class="c-header-btn-holder">
              <!-- Button when menu is available -->
              <button class="c-burger-button" v-on:click="toggleOffcanvas()"><i class="fa fa-bars" aria-hidden="true"></i></button>
            </div>
            <!-- Header Title -->
            <div class="c-has-view-title">
              <b>{{currentViewName}}</b>
            </div>
          </div>
        </div>
      </header>
      <!-- Application Body content -->
      <main class="c-main-body-wrap">
        <div class="c-responsive-container c-relative c-p-top-10">
          <!-- #region CONTENT HERE -->          
          <!-- Single Event to show -->
          <ul class="c-items-list" v-if="monthFilteredListOfEvents && monthFilteredListOfEvents.length > 0">
            <li class="c-items-for-future-events" v-for="eventItem in monthFilteredListOfEvents" v-bind:key="eventItem.eventUid" v-bind:class="returnClassWithWeekDay(eventItem.eventDate)">
              <div class="c-has-event-title"><b class="c-has-date" v-if="eventItem && eventItem.eventDate">{{eventItem.eventDate, 'DD. MMM, ddd' | glFilter_returnFormatedDate}}</b><i class="fa fa-circle" aria-hidden="true"></i><b>{{eventItem.eventName}}</b></div>
              <div class="c-has-small-details">
                <table>
                  <tbody>
                    <tr>
                      <td class="c-col-4"><i class="fa fa-map-marker" aria-hidden="true"></i>{{eventItem.eventVenue | glFilter_venue_typeName}}</td>
                      <td class="c-col-4"><i class="fa fa-calendar" aria-hidden="true"></i> {{eventItem.eventDate, 'DD. MMM YYYY.' | glFilter_returnFormatedDate}}</td>
                      <td class="c-col-4"><i class="fa fa-credit-card" aria-hidden="true"></i> Ulaz: {{eventItem.ticketPrice}}  {{eventItem.ticketPriceCurrency | glFilter_currency_typeName}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Go to Reservations button -->
              <div class="c-has-go-to-reservations" v-on:click="openEventReservations(eventItem)" v-if="glMixin_userAccessCheck(inputFirebaseUser, 'm')">
                <i class="fa fa-chevron-circle-right" aria-hidden="true"></i> <b>Pogledaj rezervacije</b>
              </div>
              <!-- Buttons -->
              <div class="c-has-buttons" v-if="glMixin_userAccessCheck(inputFirebaseUser, 'h')">
                <button class="c-btn" v-on:click="openEventDetails(eventItem)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </div>
            </li>
          </ul>
          <!-- No content message -->
          <emo-well-comp 
            v-else
            input-well-type="no-content" 
            input-txt-msg="Trenutno nema zakazanih događaja"
          ></emo-well-comp>          
          <!-- #endregion CONTENT HERE -->
        </div>
      </main>
      <!-- Application Footer Menu -->
      <footer class="c-main-footer-nav c-white-back">
        <div class="c-responsive-container c-relative">
          <!-- Add New content floating button -->
          <button v-if="glMixin_userAccessCheck(inputFirebaseUser, 'h')"
          class="c-btn c-floating-circle" v-on:click="createNewEvent()"><i class="fa fa-plus" aria-hidden="true"></i></button>
          <!-- Events filter by month -->
          <div class="c-footer-form-wrap">
            <table v-if="tempListOfAllScheduledMonths && tempListOfAllScheduledMonths.length > 0">
              <tbody>
                <tr>
                  <td class="c-col-6">Prikaži po mesecima</td>
                  <td class="c-col-6">
                    <div class="c-form-group">
                      <select v-model="selectedMonthFilter" class="c-form-control" id="filter-year-month" name="filter-year-month">
                        <option v-bind:value="null">Svi meseci</option>
                        <option v-for="singleYearMonth in tempListOfAllScheduledMonths"
                          :key="singleYearMonth"
                        >{{singleYearMonth}}</option>
                      </select>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </footer>
      <!-- Modal Templates -->
      <transition name="slide-up" mode="out-in">
        <component 
          v-if="modalComponent.isVisible" 
          v-bind:is="modalComponent.activeModalComponent"
          v-bind:input-modal-data = "modalComponent.dataForModal"
        ></component>
      </transition>
    </div>
</template>

<script>
import router from "@/router/index";
import EventBus from "@/EventBus";
import EmoWellComp from "@/components/wells/EmoWellComp";
import ModalEventDetails from "@/components/futureEvents/ModalEventDetails";
import ModalEventReservations from "@/components/futureEvents/ModalEventReservations";
import ModalCreateNewEvent from "@/components/futureEvents/ModalCreateNewEvent";
import OverlayLoader from "@/components/helpers/OverlayLoader";
import moment from "moment";
import { firebaseDB } from "@/firebase";
export default {
  name: "FutureEvents",
  props: [
    "inputFirebaseUser",
    "inputListOfVenueTypes",
    "inputListOfCurrencyUnits",
    "inputTableStatusEnums"
  ],
  components: {
    EmoWellComp: EmoWellComp,
    ModalEventDetails: ModalEventDetails,
    ModalEventReservations: ModalEventReservations,
    ModalCreateNewEvent: ModalCreateNewEvent,
    OverlayLoader: OverlayLoader
  },
  data() {
    return {
      // ~ name of current view (component title)
      currentViewName: null,
      //
      tempListOfAllScheduledMonths: [],
      selectedMonthFilter: null,
      // ~ each time we have loading process this array will have length > 0
      isLoading: [1],
      // ~ for showing modal
      modalComponent: {
        isVisible: false,
        activeModalComponent: null,
        dataForModal: null
      }
    };
  },
  firebase: function() {
    return {
      listOfFutureEvents: {
        source: firebaseDB.ref("listOfFutureEvents"),
        // this is called once the data has been retrieved from firebase
        readyCallback: function(dataSnapshot) {
          this.isLoading.pop();
          //use Lodash to sort list by date ascending
          this.listOfFutureEvents = _.orderBy(dataSnapshot.val(), 'eventDate', 'asc');
          //call function
          this.getListOfAllScheduledMonths(dataSnapshot.val());
        }
      }
    };
  },
  watch: {
    selectedMonthFilter: function(newValue) {
      //console.log("selected month filter: " + newValue);
    }
  }, 
  computed: {
    monthFilteredListOfEvents: function() {
      if (!this.selectedMonthFilter) {
        return this.listOfFutureEvents;
      } else {
        return this.listOfFutureEvents.filter(eventItem => {
          if (eventItem.eventDate) {
            var eventMonth = moment(eventItem.eventDate).format("MMMM, YYYY");
            if (eventMonth === this.selectedMonthFilter) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        });
      }
    }  
  },
  methods: {
    // ~ hide offcanvas component inside 'MainApp' component
    toggleOffcanvas: function() {
      EventBus.$emit("toggleOffcanvas");
    },
    // ~ get all months in which we have events
    getListOfAllScheduledMonths: function(inputListOfEvents) {
      this.tempListOfAllScheduledMonths = [];
      for (var key in inputListOfEvents) {
        if (inputListOfEvents.hasOwnProperty(key) && inputListOfEvents[key].eventDate) {
          var doesMonthExist = false;
          for (var i = 0; i < this.tempListOfAllScheduledMonths.length; i++) {
            if (this.tempListOfAllScheduledMonths[i] === moment(inputListOfEvents[key].eventDate).format("MMMM, YYYY")) {
              doesMonthExist = true;
              break;
            }
          }
          if (doesMonthExist === false) {
            var newMonth = moment(inputListOfEvents[key].eventDate).format("MMMM, YYYY");
            this.tempListOfAllScheduledMonths.push(newMonth);
          }
        }
      }
    },
    /* #region Event Details Modal */
    // ~ when user wants to change details for some event
    openEventDetails: function(inputEventItem) {
      console.log('inputEventItem: ' + JSON.stringify(inputEventItem, null, 2) );
      //var tempBackupEventItem = inputEventItem;
      var tempBackupEventItem = JSON.parse(JSON.stringify(inputEventItem));
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_EventDetails(inputEventItem).then(
        function(response) {
          //console.log( "Modal EventDetails returned response: " + JSON.stringify(response, null, 2) );
          if (response && response.actionStatus == "event-to-archive") {
            // If we clicked to move event to archive, then we must performe some actions
            //////// Events
            console.log('event-to-archive tempBackupEventItem: ' + JSON.stringify(tempBackupEventItem, null, 2) );
            var eventKey = tempBackupEventItem.eventUid;
            // * 1 = Copy Event to 'listOfArchivedReservations'
            firebaseDB.ref("listOfArchivedEvents").child(eventKey).set(tempBackupEventItem).then(
              function(response) {
                  // * 2 = Remove event from 'listOfFutureEvents'
                firebaseDB.ref("listOfFutureEvents").child(eventKey).remove().then(
                  function(response) {
                      this.closeModal();
                  }.bind(this),
                  function(error) {
                      // ~ close modal
                      this.closeModal();
                  }.bind(this)
                );
              }.bind(this),
                function(error) {
                  // ~ close modal
                  this.closeModal();
              }.bind(this)
            );
          } else {
            // ~ close modal
            this.getListOfAllScheduledMonths(this.listOfFutureEvents);
            this.closeModal();
          }
        }.bind(this),
        function(reject) {
          console.log("Modal EventDetails returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_EventDetails: function(inputEventItem) {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalEventDetails;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Event Details Title",
          dataForModal: {
            selectedEventObject: inputEventItem,
            listOfVenueTypes: this.inputListOfVenueTypes,
            listOfCurrencyUnits: this.inputListOfCurrencyUnits
          },
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Event Details Modal */
    /* #region Event Reservations Modal */
    // ~ when user wants to change Reservations for some event
    openEventReservations: function(inputEventItem) {
      // ~ then we need to show different page with wanted event
      var promiseFromModal = this.openModal_EventReservations(inputEventItem).then(
        function(response) {
          //console.log("Modal returned response: " + JSON.stringify(response, null, 2));
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject) {
          console.log("Modal returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_EventReservations: function(inputEventItem) {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalEventReservations;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Event Reservations Title",
          //dataForModal: inputEventItem,
          dataForModal: {
            selectedEventObject: inputEventItem,
            listOfVenueTypes: this.inputListOfVenueTypes,
            listOfCurrencyUnits: this.inputListOfCurrencyUnits,
            tableStatusEnums: this.inputTableStatusEnums,
            currentFirebaseUser: this.inputFirebaseUser
          },
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Event Reservations Modal */
    /* #region Create New Event Modal */
    // ~ when we want to create new event
    createNewEvent: function() {
      // ~ then we need to show different page with wanted content
      var promiseFromModal = this.openModal_createNewEvent().then(
        function(response) {
          //console.log("Modal returned response: " + JSON.stringify(response, null, 2));
          // ~ close modal
          this.closeModal();
        }.bind(this),
        function(reject) {
          console.log("Modal returned reject");
          // ~ close modal
          this.closeModal();
        }.bind(this)
      );
    },
    openModal_createNewEvent: function() {
      return new Promise((resolve, reject) => {
        this.modalComponent.activeModalComponent = ModalCreateNewEvent;
        this.modalComponent.isVisible = true;
        this.modalComponent.dataForModal = {
          headerTitle: "Create New Event Title",
          dataForModal: {
            listOfVenueTypes: this.inputListOfVenueTypes,
            listOfCurrencyUnits: this.inputListOfCurrencyUnits
          },
          resolve: resolve,
          reject: reject
        };
      });
    },
    /* #endregion Create New Event Modal */
    closeModal: function() {
      this.modalComponent.isVisible = false;
      this.modalComponent.activeModalComponent = null;
      this.modalComponent.dataForModal = null;
    },
    ////
    returnClassWithWeekDay: function (inputedEventDate) {
      let returnClass = '';
      if (inputedEventDate){
        returnClass = 'c-' + moment(inputedEventDate).format('dddd').toLowerCase();
      }
      return returnClass;
    }
  },
  created() {
    console.log("~ created - FutureEvents component!");
    //console.log('inputFirebaseUser: ' + JSON.stringify(this.inputFirebaseUser, null, 2) );
    // ~ call action when router is ready
    this.$router.onReady(
      function() {
        if (this.$route.meta) {
          this.currentViewName = this.$route.meta.headerTitle;
        }
      }.bind(this)
    );
  },
  mounted() {
    console.log("~ mounted - FutureEvents component!");
  },
  destroyed() {
    console.log("~ destroyed - FutureEvents component!");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/futureEvents/FutureEvents.vue